/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useRef, useEffect, useMemo } from 'react';
import type { NormalizedCacheObject } from 'apollo-cache-inmemory';
import type ApolloClient from 'apollo-client';
import giraClient from '@jira/platform__graphql-gira/src/index.tsx';
import { transformOriginUrl } from '@jira/issue-create__issue-create-commons/src/common/utils/transform-stargate-url/index.tsx';
import { useSitePickerContext } from '@jira/issue-create__use-trigger-issue-create-modal/src/controllers/use-site-picker-context/index.tsx';

export const getGiraClient = (): {
	readonly clientId: 'gira';
	readonly clientCreator: (originUrl?: string) => ApolloClient<NormalizedCacheObject>;
} => giraClient;

export const useIssueCreateFromAnywhereContext = (): {
	giraClient: {
		clientCreator: (originUrl?: string) => ApolloClient<NormalizedCacheObject>;
		clientId: 'gira';
	};
	resetAndReloadCreateForm: boolean;
} => {
	const cloudIdRef = useRef('');

	const [{ selectedCloudId }] = useSitePickerContext();

	useEffect(() => {
		if (selectedCloudId && cloudIdRef.current !== selectedCloudId) {
			cloudIdRef.current = selectedCloudId;
		}
	}, [selectedCloudId]);

	const originUrl = useMemo(() => transformOriginUrl(selectedCloudId), [selectedCloudId]);
	return {
		giraClient: {
			...getGiraClient(),
			...(originUrl && { clientCreator: () => getGiraClient()?.clientCreator(originUrl) }),
		},
		// oxlint-disable-next-line react/react-compiler
		resetAndReloadCreateForm: cloudIdRef.current !== selectedCloudId,
	};
};
